/**
 * Browser and platform sniffing.
 * Device.ts will eventually be replaced by this.
 * Device does a bit too much (modifying HTML etc).
 */
const navigator = window.navigator
const userAgent = navigator.userAgent.toLowerCase()
const screen = {
  width: window.screen.width,
  height: window.screen.height,
}

// Helper function to check if user agent includes a string.
// We can use String.prototype.includes here because polyfill adds it.
// However, i'd like this bit to be an independent module, capable of
// running on old devices as well.
const uaIncludes = (str: string): boolean => {
  return userAgent.includes(str)
}

const isTests: { [key: string]: () => boolean } = {}
const memoizedIsTests: { [key: string]: boolean } = {}

const canTests: { [key: string]: () => boolean } = {}
const memoizedCanTests: { [key: string]: boolean } = {}

// Check if Internet Explorer
isTests.ie = (): boolean => {
  return uaIncludes('msie') || (navigator.appName === 'Netscape' && uaIncludes('trident'))
}

// Check if cookies are enabled
canTests.cookies = (): boolean => {
  return navigator.cookieEnabled
}

// Safari will say cookies are enabled even when they are not.
// If we are sure that our page will have cookies, this extra check
// ensures that the browser is not lying about its ability to set cookies.
canTests.cookiesForReal = (): boolean => {
  return navigator.cookieEnabled && document.cookie !== ''
}

// Check if browser supports lazy loading natively.
canTests.lazyLoad = (): boolean => {
  return 'loading' in HTMLImageElement.prototype
}

function is(query: string): boolean {
  if (typeof memoizedIsTests[query] === 'undefined') {
    if (typeof isTests[query] !== 'undefined') {
      memoizedIsTests[query] = isTests[query]()
    } else {
      throw new Error(`Unsupported query ${query}`)
    }
  }
  return memoizedIsTests[query]
}

function can(query: string): boolean {
  if (typeof memoizedCanTests[query] === 'undefined') {
    if (typeof canTests[query] !== 'undefined') {
      memoizedCanTests[query] = canTests[query]()
    } else {
      throw new Error(`Unsupported query ${query}`)
    }
  }
  return memoizedCanTests[query]
}

export { is, can, is as browserIs, can as browserCan, userAgent, screen }
